<template>
  <el-aside :class="expandWidth" class="main-sidebar">
    <el-menu :collapse="collapse">
      <router-link to="/">
        <el-menu-item class="logo-item" data-qa="SideBar-ProductName-MenuItem" index="logo">
          <img class="logo-img" src="/src/assets/img/logo-navbar.png" alt="Logo" />
          <span slot="title">ExoHome</span>
        </el-menu-item>
      </router-link>
      <router-link to="/device">
        <el-menu-item :class="showDevicesActive" data-qa="SideBar-Devices-MenuItem" index="/device">
          <i class="fa fa-lightbulb-o" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuDevices') }}</span>
        </el-menu-item>
      </router-link>
      <router-link to="/user">
        <el-menu-item :class="showUsersActive" data-qa="SideBar-Users-MenuItem" index="/user">
          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuUsers') }}</span>
        </el-menu-item>
      </router-link>
      <router-link to="/firmware">
        <el-menu-item :class="showFirmwareActive" data-qa="SideBar-Firmware-MenuItem" index="/firmware">
          <i class="fa fa-folder" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuFirmware') }}</span>
        </el-menu-item>
      </router-link>
      <router-link to="/theme">
        <el-menu-item :class="showThemeActive" data-qa="SideBar-Theme-MenuItem" index="/theme">
          <i class="fa fa-magic" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuTheme') }}</span>
        </el-menu-item>
      </router-link>
      <router-link to="/informationModel">
        <el-menu-item :class="showIMActive" data-qa="SideBar-InformationModel-MenuItem" index="/informationModel">
          <i class="fa fa-cubes" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuInformationModel') }}</span>
        </el-menu-item>
      </router-link>
      <router-link to="/notifications">
        <el-menu-item :class="showNotifyActive" data-qa="SideBar-Notifications-MenuItem" index="/notifications">
          <i class="fa fa-comment" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuNotifications') }}</span>
        </el-menu-item>
      </router-link>
      <router-link to="/export">
        <el-menu-item :class="showExportActive" data-qa="SideBar-Export-MenuItem" index="/export">
          <i class="fa fa-download" aria-hidden="true"></i>
          <span slot="title">{{ $t('sidebarMenuExport') }}</span>
        </el-menu-item>
      </router-link>
    </el-menu>
  </el-aside>
</template>

<script>
  import main from './Sidebar.js'
  export default main
</script>

<style lang="scss" scoped>
@import './Sidebar.scss'
</style>



// WEBPACK FOOTER //
// Sidebar.vue?c0a178b0